<template>
	<div>
		<v-card class="sidebar">
			<v-list class="sidebar-list pa-0">
				<a class="sidebar-link" :href="bannerUrl" target='_blank'>
					<img
						style="width: 100%; border-radius: 10px;"
						:src="imageSource"
						alt="add banner"
						loading="lazy"
					/>
				</a>
			</v-list>
		</v-card>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'AdBanner',
	computed: {
		...mapGetters('settings', ['web']),
		imageSource() {
			if (!this.web) {
				return ''
			}
			return this.web.banner_image
		},
		bannerUrl() {
			if (!this.web) {
				return ''
			}
			return this.web.banner_url
		},

	},
}
</script>

<style scoped lang="scss">
.sidebar {
	margin-top: 28px;
	max-width: 250px;
	width: 100%;
	border-radius: 10px !important;
	box-shadow: none !important;

	&-link {
		display: flex;
	}
}
</style>
